import { REFERENTIEL_TYPE } from '../../administration/gestion-référentiels/models/référentiel-type.enum';
import { ÉQUIPE_RESPONSABLE } from '../../administration/gestion-référentiels/models/équipe-responsable.enum';
import { INSTITUTS_MÉTIER } from './instituts-métier';

export const SERVICE_INSTITUTS_METIER = [
  {
    nom: 'Collège des métiers',
    items: Array.from(INSTITUTS_MÉTIER, ([acronyme, nom]) => ({
      href: acronyme,
      nom: nom,
      type: REFERENTIEL_TYPE.METIER,
    })),
  },
  {
    nom: 'Socle',
    items: [
      {
        href: ÉQUIPE_RESPONSABLE.FORMATEUR,
        nom: ÉQUIPE_RESPONSABLE.FORMATEUR,
        type: REFERENTIEL_TYPE.FORMATEUR,
      },
      {
        href: ÉQUIPE_RESPONSABLE.SCIENCES_ET_CULTURE,
        nom: ÉQUIPE_RESPONSABLE.SCIENCES_ET_CULTURE,
        type: REFERENTIEL_TYPE.SCIENCES_ET_CULTURE,
      },
      {
        href: ÉQUIPE_RESPONSABLE.COMPAGNONNIQUE,
        nom: ÉQUIPE_RESPONSABLE.COMPAGNONNIQUE,
        type: REFERENTIEL_TYPE.COMPAGNONNIQUE,
      },
      {
        href: ÉQUIPE_RESPONSABLE.TRANSVERSE,
        nom: ÉQUIPE_RESPONSABLE.TRANSVERSE,
        type: REFERENTIEL_TYPE.TRANSVERSE,
      },
    ],
  },
];
